/* eslint-disable object-property-newline */
import React from 'react';
import UserPositionRenderer from "../../dataViewers/map/mapbox/renderers/UserPositionRenderer.js";
import UserPositionModel from "../../dataViewers/map/shared/renderers/UserPositionModel.js";
export default {
  id: 'molten.UserPositionRenderer',
  matches: {
    client: 'MapDataViewer'
  },
  layerName: 'molten.userPosition',
  sort: 'aaa',
  createModel(lastModel) {
    if (lastModel == null) {
      return UserPositionModel.create();
    }
    return lastModel;
  },
  create: props => {
    return /*#__PURE__*/React.createElement(UserPositionRenderer, {
      ...props,
      key: 'userPosition'
    });
  }
};